import { Component, Input } from '@angular/core';

import { CaGroup } from '../../../core';
import { createNewMyFocusHandle } from '../../function/create-handle.function';
import { currentState } from '../../state';
import { State } from '../../state.model';

@Component({
    selector: 'cmps-ca-evaluation-phase-actions',
    templateUrl: './phase-actions.component.html',
})
export class PhaseActionsComponent {
    @Input()
    group: CaGroup;

    @Input()
    ref: HTMLElement;

    /** @private */
    _state: State;

    constructor() {
        this._state = currentState();
    }

    /** @private */
    _onAddMyFocusClick(): void {
        createNewMyFocusHandle(this.group.name, this.ref);
    }
}
